<template>
	<div class="deviceList content-wrapper" ref="deviceList" id="deviceList">
		<el-form :model="form" ref="form" :inline="true" class="demo-form-inline searchModl" size="small">
<!--			<el-form-item prop="deviceNo">
				<el-select v-model="form.deviceNo" clearable placeholder="充检站" class="elInput150"
					@change="onDataList()">
					<el-option v-for="item in allList" :key="item.deviceNo" :label="item.stationName"
						:value="item.deviceNo">
					</el-option>
				</el-select>
			</el-form-item>-->
			<el-form-item prop="vin">
				<el-input v-model="form.vin" placeholder="VIN码或订单号" clearable class="elInput150" />
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="dateRange" style="width: 240px" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
					type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button class="querybtn" plain @click="onDataList">查询</el-button>
				<el-button class="cancelbtn" plain @click="onClearable('form')">清空
				</el-button>
			</el-form-item>
			<el-form-item style="float: right;">

			</el-form-item>
		</el-form>

		<el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-background="#121C2B" :data="dataList"
			:height="tableHeight" border highlight-current-row size="small" @sort-change="onSortChange"
			ref="multipleTable">
			<el-table-column type="index" :index="indexMethod" label="序号" width="50" align="center">
			</el-table-column>
			<el-table-column prop="beginTime" label="开始时间" width="140" align="center"></el-table-column>
<!--			<el-table-column prop="stationName" label="站点" width="150"
				align="center"></el-table-column>-->
			<el-table-column prop="vin" label="VIN码" width="150"  align="center"></el-table-column>
			<el-table-column prop="recordCode" label="订单号" width="160" 
				align="center"></el-table-column>
			<el-table-column prop="flag" label="" width="30" align="center">
				<template slot-scope="scope">
					<span
						style="font-weight: bold;font-size: 25px;display: block;height: 12px;">{{scope.row.flag==0?'*':''}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="score" label="车检得分" width="80" align="center"></el-table-column>
			<el-table-column prop="capacityMetrics" label="容量特性SOH" width="110" align="center">
			</el-table-column>
			<el-table-column prop="energyIndicator" label="能量特性SOE" width="110" align="center"></el-table-column>
			<el-table-column prop="sot" label="温度特性SOT" width="110" align="center"></el-table-column>
			<el-table-column prop="consistency" label="一致性" align="center" width="70"></el-table-column>
			<el-table-column prop="thermalRunaway" label="热失控" align="center" width="70"></el-table-column>
			<el-table-column prop="cooling" label="冷却系统" align="center" width="80"></el-table-column>
			<el-table-column prop="seal" label="气密性" align="center"></el-table-column>
			<!-- <el-table-column prop="rulDays" label="剩余寿命" align="center" width="120"></el-table-column> -->
			<el-table-column prop="initSoc" label="起始SOC" width="80" align="center"></el-table-column>
			<el-table-column prop="currentSoc" label="当前SOC" width="80" align="center"></el-table-column>
			<el-table-column prop="updateTime" label="最后更新时间" width="140" align="center"></el-table-column>

			<!-- <el-table-column prop="batteryInsulation" label="绝缘状态" width="110" align="center"></el-table-column>
			<el-table-column prop="failureMetrics" label="故障指标" width="110" align="center"></el-table-column>
			<el-table-column prop="maxAllowableElectricityAlarm" label="需求电流" width="110"
				align="center"></el-table-column>
			<el-table-column prop="maxAllowableVoltageAlarm" label="需求电压" width="110" align="center"></el-table-column>
			<el-table-column prop="socAlarm" label="SOC跳变" width="110" align="center"></el-table-column>
			<el-table-column prop="tempDiffAlarm" label="最大温差" width="110" align="center"></el-table-column>
			<el-table-column prop="tempRiseAlarm" label="最高温度变化率" width="110" align="center"></el-table-column>
			<el-table-column prop="singleVoltageStatus" label="单体电压" width="110" align="center"></el-table-column>
			<el-table-column prop="socStatus" label="SOC荷电" width="110" align="center"></el-table-column>
			<el-table-column prop="electricityStatus" label="充电过电流" width="110" align="center"></el-table-column>
			<el-table-column prop="tempStatus" label="温度状态" width="110" align="center"></el-table-column>
			<el-table-column prop="insulationStatus" label="输出连接器连接" width="110" align="center"></el-table-column>
			<el-table-column prop="bmsStopChargeFault" label="BMS终止充电故障" width="140" align="center"></el-table-column>
			<el-table-column prop="bmsStopChargeError" label="BMS终止充电错误" width="140" align="center"></el-table-column>

			<el-table-column prop="beginTime" label="开始时间" width="140" align="center"></el-table-column>
			<el-table-column prop="endTime" label="结束时间" width="140" align="center"></el-table-column>
			 -->
			<el-table-column label="操作" width="320" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button @click="onLook(scope.row)" type="text" size="small">查看
					</el-button>
					<!-- <el-button @click="onPrint(scope.row)" type="text" size="small">导出报告
					</el-button> -->
					<router-link class="routerlink" target="_blank" style="margin:0px 10px;"
						:to="{path:'/exportReport4',query:{pileCode:scope.row.pileCode,recordCode:scope.row.recordCode}}">
						预览</router-link>
					<!-- <el-button @click="onDownData(scope.row)" type="text" size="small">充电数据
					</el-button>
					<el-button @click="onYuanData(scope.row)" type="text" size="small">源数据
					</el-button> -->
					<el-button @click="onInfo(scope.row)" type="text" size="small">详情
					</el-button>
					<!-- <el-button @click="onCalculate(scope.row)" type="text" size="small">重新计算
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
			:page-sizes="[10, 20, 30, 60]" :page-size="limit" layout="total, sizes, prev, pager, next" :total="total">
		</el-pagination>

		<vue-easy-print ref="easyPrint" class="easyprint">
			<exportReport :formPrint="formPrint" :pileCode="pileCodeStr" :recordCode="recordCodeStr"
				@feedback="onfeedback" id="pdfPrint"></exportReport>
		</vue-easy-print>

		<el-dialog title="" :visible.sync="dialogVisible" width="1000px">
			<el-divider content-position="center">异常指标</el-divider>
			<ul class="formul">
				<li><span
						:class="formData.singleVoltageStatus=='正常'?'':'unusual'">单体电压状态</span><b>{{formData.singleVoltageStatus}}</b>
				</li>
				<li><span :class="formData.socStatus=='正常'?'':'unusual'">SOC荷电状态</span><b>{{formData.socStatus}}</b>
				</li>
				<li><span
						:class="formData.electricityStatus=='正常'?'':'unusual'">充电过电流状态</span><b>{{formData.electricityStatus}}</b>
				</li>
				<li><span :class="formData.tempStatus=='正常'?'':'unusual'">温度状态</span><b>{{formData.tempStatus}}</b></li>
				<li><span
						:class="formData.batteryInsulation=='正常'?'':'unusual'">电池绝缘状态</span><b>{{formData.batteryInsulation}}</b>
				</li>
				<li><span
						:class="formData.insulationStatus=='正常'?'':'unusual'">输出连接器连接状态</span><b>{{formData.insulationStatus}}</b>
				</li>
				<li><span
						:class="formData.bmsInsulationError=='正常'?'':'unusual'">bms-绝缘状态</span><b>{{formData.bmsInsulationError}}</b>
				</li>
				<li><span
						:class="formData.bmsOverTempError=='正常'?'':'unusual'">bms-输出连接器过温状态</span><b>{{formData.bmsOverTempError}}</b>
				</li>
				<li><span
						:class="formData.bmsConnectError=='正常'?'':'unusual'">bms-充电连接器状态</span><b>{{formData.bmsConnectError}}</b>
				</li>
				<li><span
						:class="formData.bmsBatteryOverTempError=='正常'?'':'unusual'">bms-电池组温度状态</span><b>{{formData.bmsBatteryOverTempError}}</b>
				</li>
				<li><span
						:class="formData.bmsHighVoltageError=='正常'?'':'unusual'">bms-高压继电器状态</span><b>{{formData.bmsHighVoltageError}}</b>
				</li>
				<li><span
						:class="formData.bmsVoltageError=='正常'?'':'unusual'">bms-检测点电压状态</span><b>{{formData.bmsVoltageError}}</b>
				</li>
				<li><span
						:class="formData.bmsOtherError=='正常'?'':'unusual'">bms-其他故障状态</span><b>{{formData.bmsOtherError}}</b>
				</li>
				<li><span
						:class="formData.bmsElectricityOverFault=='正常'?'':'unusual'">bms-电流过大状态</span><b>{{formData.bmsElectricityOverFault}}</b>
				</li>
				<li><span
						:class="formData.bmsVoltageFault=='正常'?'':'unusual'">bms-电压异常状态</span><b>{{formData.bmsVoltageFault}}</b>
				</li>
				<li><span :class="formData.socAlarm=='正常'?'':'unusual'">soc跳变</span><b>{{formData.socAlarm}}</b></li>
				<li><span
						:class="formData.tempDiffAlarm=='正常'?'':'unusual'">温差异常</span><b>{{formData.tempDiffAlarm}}</b>
				</li>
				<li><span
						:class="formData.tempRiseAlarm=='正常'?'':'unusual'">温度变化率</span><b>{{formData.tempRiseAlarm}}</b>
				</li>
				<li><span
						:class="formData.maxAllowableVoltageAlarm=='正常'?'':'unusual'">最大需求电压</span><b>{{formData.maxAllowableVoltageAlarm}}</b>
				</li>
				<li><span
						:class="formData.maxAllowableElectricityAlarm=='正常'?'':'unusual'">最大需求电流</span><b>{{formData.maxAllowableElectricityAlarm}}</b>
				</li>
			</ul>

			<el-divider content-position="center">安全风险体系</el-divider>
			<!-- <ul class="formul">
				<li><span>雷达图</span><b>{{formData.securitySystemLevel}}</b></li>
				<li><span>充电异常警示</span><b>{{formData.chargeAlarm}}</b></li>
				<li><span>热失控</span><b>{{formData.tri}}</b></li>
				<li><span>性能衰减</span><b>{{formData.soh}}</b></li>
				<li><span>一致性</span><b>{{formData.consistence}}</b></li>
				<li><span>气密性异常</span><b>{{formData.cooling}}</b></li>
			</ul> -->
			<div class="safediv">
				<p style="color: rgba(255,255,255,0.6);">安全体系等级 <b
						:style="{'font-size': '1.5rem','color':(formData.securitySystemLevelValue==0?'green':'orange')}">{{ onsecurityVlue(formData.securitySystemLevelValue) }}</b>
				</p>
				<p style="color: rgba(255,255,255,0.6);">安全体系分为5个等级，等级越高，代表性能越好</p>
				<div id="echartlei"></div>
			</div>

			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span> -->
		</el-dialog>

	</div>
</template>

<script>
	import exportReport from './exportReport'
	import vueEasyPrint from 'vue-easy-print'
	export default {
		components: {
			exportReport,
			vueEasyPrint,
		},
		data() {
			return {
				dialogVisible: false,
				formData: {},
				tableHeight: "600",
				loading: false,
				dataList: [],
				form: {
					deviceNo: '',
					pileCode: '',
					vin: '',
				},
				dateRange: ['', ''],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},

				limit: 10,
				pageNum: 1,
				total: 0,

				scoreSort: 2,


				allList: [],
				deviceList: [],

				hrefdata: '',

				pileCodeStr: '',
				recordCodeStr: '',
				reportFlog: false,

				formPrint: {},
			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			if (query.vin == undefined) {
				_this.form.vin = '';
			} else {
				_this.form.vin = query.vin;
			}

			this.$nextTick(() => {
				let height = this.$refs.deviceList.clientHeight;
				_this.tableHeight = height - 130;
			})
			_this.hrefdata = this.$api.rootApi + '/order/download/data?Authorization=' + sessionStorage.getItem(
				'Authorization');

			_this.onAllList();
			_this.onDataList();


			window.onresize = function() {
				let height = document.getElementById('deviceList').clientHeight;
				_this.tableHeight = height - 130;
			}

		},
		methods: {
			onCalculate: function(item) {
				let _this = this;
				this.$api.post('/order/refresh/calculate', {
						recordCode: item.recordCode
					},
					function(response, context) {
						_this.$message({
							showClose: true,
							message: response.code == "200" ? "执行成功" : response.message,
							type: response.code == "200" ? 'success' : 'error'
						});
					}
				);
			},
			onsecurityVlue(value) {
				let str = '';
				switch (value) {
					case '0':
						str = '优';
						break;
					case '1':
						str = '良';
						break;
					case '2':
						str = '差';
						break;
					default:
						break;
				}
				return str
			},
			onInfo: function(item) {
				let _this = this;
				_this.dialogVisible = true;
				_this.formData = item;
				setTimeout(function() {
					_this.onRadar(item.securitySystemLevel);
				}, 1000);
			},
			onfeedback: function(value1, valu2) {
				let _this = this;
				console.log(value1, valu2)
				if (_this.pileCodeStr == '') return;
				if (value1 == '200') {
					_this.reportFlog = false;
					setTimeout(function() {
						_this.$refs.easyPrint.print();
					}, 500);
				} else {
					_this.$message({
						showClose: true,
						message: valu2,
						type: value1 == "200" ? 'success' : 'error'
					});
				}
			},
			onPrint: function(item) {
				let _this = this;
				this.pileCodeStr = item.pileCode;
				this.recordCodeStr = item.recordCode;
				this.reportFlog = true;
				this.onReportPreview();

			},
			// 查询所有充电站
			onAllList: function() {
				let _this = this;
				this.$api.post('/station/list/all', {},
					function(response, context) {
						if (response.code == "200") {
							_this.allList = response.data;
						}
					}
				);
			},
			// 查询站点下的所有桩
			onDeviceList: function() {
				let _this = this;
				this.$api.post('/station/device/subordinate', {
						deviceNo: _this.deviceNo, //站点编号
					},
					function(response, context) {
						if (response.code == "200") {
							_this.pileCode = '';
							_this.deviceList = response.data;
						}
					}
				);
			},
			onClearable: function(formName) {
				this.$refs[formName].resetFields();
				this.dateRange = ['', ''];
				this.onDataList();
			},
			onDataList: function() {
				let _this = this;

				let time = (_this.dateRange.length === 0 ? ['', ''] : _this.dateRange);
				this.$api.post('/order/list', {
						pileCode: _this.form.pileCode, //充电桩编号
						deviceNo: _this.form.deviceNo, //站点编号
						limit: _this.limit, //每页数据条数
						pageNum: _this.pageNum, //第几页
						beginTime: time[0], //开始时间
						endTime: time[1], //结束时间
						scoreSort: _this.scoreSort, //检测得分排序(升序：1 降序：2)
						vin: _this.form.vin,
					},
					function(response, context) {
						if (response.code == "200") {
							let data = response.data;
							_this.dataList = data.records;
							_this.total = data.total;
							_this.droneLoading = false;
						} else {
							_this.droneList = [];
							_this.$message({
								showClose: true,
								message: "检车记录列表：" + response.message,
								type: response.code == "0" ? 'success' : 'error'
							});
							_this.droneLoading = false
						}
						_this.$nextTick(() => {
							_this.$refs.multipleTable.doLayout();
						});
					}
				);
			},
			onSortChange: function(item) {
				switch (item.order) {
					case 'descending':
						this.scoreSort = 2;
						break;
					case 'ascending':
						this.scoreSort = 1;
						break;
					default:
						this.scoreSort = '';
						break;
				}
				// this.scoreSort = item.order == 'ascending' ? 1 : 2;
				this.onDataList();
			},
			onLook: function(item) {
				this.$router.push('/index?pileCode=' + item.pileCode + '&recordCode=' + item.recordCode);
			},
			onDownData: function(item) {
				let url = this.hrefdata + '&pileCode=' + item.pileCode + '&recordCode=' + item.recordCode;
				window.location.href = url;
			},
			onYuanData: function(item) {
				let hrefdata = this.$api.rootApi + '/order/download/source/data?Authorization=' +
					sessionStorage.getItem('Authorization');
				let url = hrefdata + '&recordCode=' + item.recordCode;
				window.location.href = url;
			},
			onExportReport: function() {
				this.$router.push('/exportReport');
			},

			indexMethod: function(index) {
				return index + 1;
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.limit = val;
				this.pageNum = 1;
				this.onDataList();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
				this.onDataList();
			},
			// 车检报告预览数据
			onReportPreview: function() {
				let _this = this;
				this.$api.post('/order/report/preview', {
						pileCode: _this.pileCodeStr, //充电桩编号
						recordCode: _this.recordCodeStr, //订单编号
					},
					function(response, context) {
						if (response.code == "200") {
							_this.formPrint = response.data;
						}
					}
				);
			},

			onRadar: function(item) {
				let _this = this;
				_this.radarchart1 = this.$echarts.init(document.getElementById('echartlei'));
				var indicator = [{
						name: '充电异常',
						max: 5,
						num: 1
					},
					{
						name: '热失控',
						max: 5,
						num: 2
					},
					{
						name: '性能衰减',
						max: 5,
						num: 3
					},
					{
						name: '一致性',
						max: 5,
						num: 4
					},
					{
						name: '气密性',
						max: 5,
						num: 5
					},
				];
				var dataValue = [item.chargeAlarm, item.tri, item.soh, item.consistence, item.consistence]
				var dataArr = [{
					value: dataValue,
					name: '',
					itemStyle: {
						normal: {
							lineStyle: {
								color: '#17E7FF',
							},
							shadowColor: '#17E7FF',
							shadowBlur: 5,
						},
					}
				}];

				function contains(arr, obj) {
					var i = arr.length;
					while (i--) {
						if (arr[i].name === obj) {
							return i;
						}
					}
					return false;
				}
				var num = 80;
				var option = {
					title: {
						show: false
					},
					color: ['#17E7FF'],
					radar: {
						radius: '70%',
						center: ['50%', '55%'],
						triggerEvent: true, //开启雷达图的边角名称可点击
						name: {
							textStyle: {
								padding: [10, 10, 0, 10],
							},
							formatter: (value) => {
								let i = contains(indicator, value); // 处理对应要显示的样式
								return '{a|' + dataValue[i] + '}\n' + '{b|' + value + '}';
							},
							rich: {
								a: {
									align: 'center',
									color: '#6EFFFD',
									fontWeight: 500,
									fontSize: 16,
								},
								b: {
									align: 'center',
									color: '#FFFFFF',
									fontSize: 10,
								},
								// triggerEvent: true,//开启雷达图的边角名称可点击
							},
						},

						nameGap: 8,
						indicator: indicator,
						splitArea: {
							// 坐标轴在 grid 区域中的分隔区域，默认不显示。
							show: false,
						},
						axisLine: {
							//轴线
							show: true,
							lineStyle: {
								color: this.$echarts.graphic.RadialGradient(0.5, 0.5, 1, [{
										color: '#15506D0D',
										offset: 0,
									},
									{
										color: '#95E4F0',
										offset: 0.9,
									},
								]),
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(153, 209, 246, 0.5)', // 网格分割线颜色
							},
						},
					},
					series: [{
						type: 'radar',
						symbolSize: 8,
						symbol: 'circle',
						data: dataArr,
						areaStyle: {
							color: '#9EDDFF',
							opacity: 0.3,
						},
						lineStyle: {
							color: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							width: 3,
						},
						itemStyle: {
							color: '#fff ',
							borderColor: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							borderWidth: 2,
							opacity: 1,
						}
					}],
				};

				_this.radarchart1.setOption(option, true);
				window.addEventListener("resize", function() {
					_this.radarchart1.resize();
				});
				var imgSrc = _this.radarchart1.getDataURL();
				$('#radarimg').attr('src', imgSrc).show();
				$('#radarimg').css('display', 'none');
			},


		},
		beforeDestroy() { //销毁前状态
		}
	}
</script>

<style lang="scss" scoped>
	.deviceList {
		width: 100%;
		height: 100%;
		padding: 20px;

		.el-table__row .el-button--text span,
		.routerlink {
			color: #409EFF !important;
			cursor: pointer !important;
		}

		.el-divider {
			background: rgba(255, 255, 255, 0.6);

			.el-divider__text {
				background-color: #0D283F !important;
				color: white;
			}
		}

		.formul {
			color: rgba(255, 255, 255, 0.6);
			padding: 0px;
			margin-bottom: 50px;

			li {
				width: 23%;
				border: 1px dashed rgba(255, 255, 255, 0.6);
				display: inline-block;
				line-height: 40px;
				margin: 5px 1%;
				padding: 0px 20px;
				display: inline-flex;
				justify-content: space-between;
				align-items: center;

				b {
					display: inline-block;
					width: max-content;
					color: #51F3F7;
				}
			}

			.unusual+b {
				color: red;
			}
		}

		.safediv {
			position: relative;
			width: 100%;
			height: 250px;

			#echartlei {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				margin: auto;
			}
		}

		#echartlei {
			width: 250px;
			height: 250px;
		}
	}
</style>